module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#crime",
      toString: function () {
        return this.url;
      }
    }